import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import * as React from 'react';
import classNames from 'classnames';
import '../../utils/fetcher.js';
import { prependPrefix } from '../../utils/style.js';

var LegacyTab = function LegacyTab(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: prependPrefix('legacy-tab-content')
  }, children);
};
var LegacyTabs = function LegacyTabs(props) {
  var _context;

  var id = props.id,
      className = props.className,
      activeKey = props.activeKey,
      divider = props.divider,
      onSelect = props.onSelect;

  var children = _filterInstanceProperty(_context = props.children).call(_context, function (child) {
    return !!child;
  });

  var activeTab = _filterInstanceProperty(children).call(children, function (tab) {
    return tab.props.actionKey === activeKey;
  });

  var tabs = _mapInstanceProperty(children).call(children, function (child) {
    var _child$props = child.props,
        actionKey = _child$props.actionKey,
        title = _child$props.title;
    return /*#__PURE__*/React.createElement("li", {
      key: actionKey,
      className: classNames('tab', {
        active: actionKey === activeKey
      }),
      onClick: function onClick() {
        return onSelect === null || onSelect === void 0 ? void 0 : onSelect(actionKey || '');
      }
    }, title);
  });

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(prependPrefix('legacy-tabs'), className),
    id: id || ''
  }, /*#__PURE__*/React.createElement("ul", {
    className: classNames('tab-list', {
      divider: divider
    })
  }, tabs), activeTab);
};

export { LegacyTab, LegacyTabs };
